import React, { Fragment, useState, useEffect } from 'react'
import axios from 'axios'
import { toast } from 'react-toastify'

import { Heading } from '@peracto/peracto-ui'
import { useConfig } from '@peracto/peracto-config'

import { DashboardOrders } from './DashboardOrders'
import { DashboardMenus } from './DashboardMenus'
import { DashboardPages } from './DashboardPages'

const Dashboard = () => {
    const config = useConfig()
    const API_URL = config.get('api')

    const [ordersLoading, setOrdersLoading] = useState(true)
    const [ordersData, setOrdersData] = useState()

    const [menuLoading, setMenuLoading] = useState(true)
    const [menuData, setMenuData] = useState()

    const [pagesLoading, setPagesLoading] = useState(true)
    const [pagesData, setPagesData] = useState()

    const getData = async (slug, setData, setLoading) => {
        try {
            const res = await axios.get(`${API_URL}${slug}`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
            })

            const data = res.data && res.data['hydra:member']
            if (data) {
                setData(data)
                setLoading(false)
            }
        } catch (e) {
            setLoading(false)
            toast.error(
                e?.error?.body?.hasOwnProperty('hydra:description')
                    ? e.error.body['hydra:description']
                    : 'Whoops, there was a problem...'
            )
        }
    }

    const getDashboardData = async () => {
        await getData('/orders?page=1&itemsPerPage=5', setOrdersData, setOrdersLoading)
        await getData('/menus?page=1&itemsPerPage=5', setMenuData, setMenuLoading)
        await getData('/contents?page=1&itemsPerPage=5&type=page', setPagesData, setPagesLoading)
    }

    useEffect(() => {
        getDashboardData()
    }, [])

    return (
        <Fragment>
            <Heading name="Dashboard" />
            <DashboardOrders data={ordersData} loading={ordersLoading} />
            <DashboardPages data={pagesData} loading={pagesLoading} />
            <DashboardMenus data={menuData} loading={menuLoading} />
        </Fragment>
    )
}

export default Dashboard
